/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type PdpRespContainer_displayInfo = {
    readonly pricing?: {
        readonly " $fragmentRefs": FragmentRefs<"PdpSharedTradePointsEarnedMessage_priceInfoDisplay">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespSidebarButtons_displayInfo" | "PdpRespSidebarContact_displayInfo" | "PdpSharedPromoCode_displayInfo" | "PdpRespSidebarBlurbs_displayInfo" | "PriceDisplay_displayInfo">;
    readonly " $refType": "PdpRespContainer_displayInfo";
};
export type PdpRespContainer_displayInfo$data = PdpRespContainer_displayInfo;
export type PdpRespContainer_displayInfo$key = {
    readonly " $data"?: PdpRespContainer_displayInfo$data;
    readonly " $fragmentRefs": FragmentRefs<"PdpRespContainer_displayInfo">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "PdpRespContainer_displayInfo",
  "type": "ItemDisplayInfo",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "isTrade",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarButtons_displayInfo",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarContact_displayInfo",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpSharedPromoCode_displayInfo",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PdpRespSidebarBlurbs_displayInfo",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "PriceDisplay_displayInfo",
      "args": null
    },
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "isTrade",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "pricing",
          "storageKey": null,
          "args": null,
          "concreteType": "PriceInfoDisplay",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "PdpSharedTradePointsEarnedMessage_priceInfoDisplay",
              "args": null
            }
          ]
        }
      ]
    }
  ]
};
(node as any).hash = 'bb53645122f15a015cee921b18b1f34b';
export default node;
